import { ApiClient } from "@/lib/apiClient";

export interface UserSubscription {
  user_id: string;
  plan_type: string;
  status: string;
  started_at?: string;
  expires_at?: string;
  stripe_customer_id?: string;
}

export class SubscriptionService {
  static async getUserPlan(userId: string): Promise<UserSubscription | null> {
    if (!userId) {
      return null;
    }

    try {
      const { data, error } = await ApiClient.getUserSubscription();

      if (error) {
        console.error('Error fetching user subscription:', error);
        // Fallback to free plan on error
        return {
          user_id: userId,
          plan_type: 'free',
          status: 'active'
        };
      }

      if (!data) {
        // No subscription found, return free plan as default
        return {
          user_id: userId,
          plan_type: 'free',
          status: 'active'
        };
      }

      // Return the subscription data from the API
      return data;
    } catch (error) {
      console.error('Failed to get user plan:', error);
      // Fallback to free plan if there's an error
      return {
        user_id: userId,
        plan_type: 'free',
        status: 'active'
      };
    }
  }

  static async getUserPlanType(userId: string): Promise<string> {
    const subscription = await this.getUserPlan(userId);
    return subscription?.plan_type || 'free';
  }
}